import React from "react";
import { useNavigate } from "react-router-dom";
import "../../Css/UserProfile.css";
import { useAuth } from "../../Middleware/context/AuthContext";
function UserProfile() {
  const navigate = useNavigate();
  const {user,userProfile}=useAuth()

  return (
    <div className="profilePage">
      <h2>{userProfile?.nome}</h2>

      <div className="profileCard">
        <div className="profileRow">
          <span>Balance:</span>
          <p>{userProfile?.saldo} AoA</p>
        </div>

        <div className="profileRow">
          <span>Email:</span>
          <p>{user?.email}</p>
        </div>

        <div className="profileRow">
          <span>Telefone:</span>
          <p>{userProfile?.telefone}</p>
        </div>

        <div className="profileRow">
          <span>BI:</span>
          <p>{userProfile?.idCard}</p>
        </div>

        <div className="profileRow">
          <span>Morada:</span>
          <p>{userProfile?.location}</p>
        </div>

        <div className="profileActions">
          <button onClick={() => navigate("/User/Update")}>Editar</button>
          <button className="back" onClick={() => navigate(-1)}>
            Regressar
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
